import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=402d40a2&scoped=true"
import script from "./Speaker.vue?vue&type=script&lang=js"
export * from "./Speaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d40a2",
  null
  
)

export default component.exports